import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=bec74d1a&scoped=true"
import script from "./courseDetail.vue?vue&type=script&lang=js"
export * from "./courseDetail.vue?vue&type=script&lang=js"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=bec74d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec74d1a",
  null
  
)

export default component.exports